import React from 'react';
import { PrimeReactProvider } from "primereact/api";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { ChnLayoutPage } from "@chainless/chainless-react";
import { Toast } from "primereact/toast";
import { ReportGenerator } from './ReportGenerator';
import { ToastContextProvider } from 'src/toastProvider';

function App() {
  const toast = React.useRef<Toast>(null);
  const tabs = [
    {
      name: "Naregelingen",
      route: "/naregeling",
    },
    {
      name: "Modbus",
      route: "/modbus",
    },
  ];

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <PrimeReactProvider>
          <ToastContextProvider>
            <ChnLayoutPage tabs={tabs} name={"Rapportage"}></ChnLayoutPage>
            <Toast ref={toast} />
          </ToastContextProvider>
        </PrimeReactProvider>
      ),
      children: [
        {
          path: "",
          children: [
            {
              path: "/naregeling",
              element: <ReportGenerator path="/naregeling" title='Naregeling Rapportage' />,
            },
            {
              path: "/modbus",
              element: <ReportGenerator path="/modbus" title='Modbus Rapportage' />,
            },
            {
              path: "",
              element: <Navigate to="/naregeling" replace />,
            },
          ],
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
